module.exports = require('./dist/icon');